<template>
  <div class="flex-folders">
    <BaseModal v-model="wipeconfirm" hide-footer title="Delete survey permanently?">
      WARNING! This operation will physically delete ALL information for this survey, including survey participants,
      answers to survey questions, and all reports.
      <p><strong>THIS OPERATION CANNOT BE REVERSED.</strong></p>
      <template #footer>
        <button class="btn btn-danger mt-3 w-100" @click="survey_deletefromdatabase(wipesurvey)">
          Delete
        </button>
        <button class="btn btn-secondary mt-2 w-100" @click="wipeconfirm = false; wipesurvey = false;">
          Cancel
        </button>
      </template>
    </BaseModal>
    <BaseModal v-model="wipeprogress" hide-footer title="Permanently deleting survey">
      <div class="row">
        <div class="col-12 text-center">
          <h5>Deleting survey</h5>
        </div>
      </div>
      <div class="col-12 text-center">
        <div class="spinner-grow text-danger" style="width: 4rem; height: 4rem;" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </BaseModal>
    <div class="flex-table d-flex flex-column">
      <div v-if="loading" class="text-center text-success my-2">
          <div class="spinner-border align-middle me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <strong>Loading...</strong>
      </div>
      <div v-for="survey in surveys" :key="survey.id" :busy="loading" class="flex-table-survey">
        <div class="d-flex justify-content-between">
          <div class="flex-table-survey-info" @click.prevent="openSurveyPage(survey)">
            <div class="d-flex justify-content-start flex-table-row align-items-center">
              <i class="fa fa-regular fa-square-poll-vertical"></i>
              <div class="flex-table-title">
                {{ survey.survey_type_id }}: {{ survey.survey_name }}
              </div>
              <div :class="getClassColor('member', survey)" class="pill">{{ survey.completecount }}/{{
                survey.membercount }}</div>
              <div :class="getClassColor('status', survey)" class="pill">{{ surveyTypeName(survey.survey_status_id) }}
              </div>
            </div>
            <div class="d-flex pl-start-long justify-content-start flex-table-row align-items-center">
              <i class="fa fa-regular fa-users"></i>
              <div>{{ survey.group_id }}</div>
              <div>
                {{
                  survey.survey_start_date > '1970-01-02' ?
                    `${format_date(survey.survey_start_date)}—${format_date(survey.survey_end_date)}`
                    : 'Dates not set'
                }}
                </div>
            </div>
          </div>
          <div class="ellipsis-button d-flex align-items-center">
            <BaseDropdown right variant="link">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="openSurveyPage(survey)">Edit</a>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="wipeconfirm = true; wipesurvey = survey.id">
                  Delete
                </a>
              </li>
            </BaseDropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="total-show" v-if="!loading">
      <span>Showing {{ surveys_retrieved }} of {{ surveys_total }} surveys</span><a class="ms-3" href="/surveys">Show
        all</a>
    </div>
  </div>
</template>
<script>
import BaseModal from '../base/BaseModal.vue'
import BaseDropdown from '../base/BaseDropdown.vue'

export default {
  components: {
    BaseModal,
    BaseDropdown
  },
  props: {
    surveytype: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      wipeconfirm: false,
      wipeprogress: false,
      wipesurvey: 0,
      consultant_id: this.$store.state.user_id,
      loading: true,
      selected: 0,
      surveysselected: 0,
      surveys_total: 0,
      surveys_retrieved: 10,
      fields: [
        {
          key: 'survey_type_id',
          sortable: true,
          label: 'Type',
          tdClass: 'd-none d-sm-none d-md-none d-lg-none d-xl-table-cell',
          thClass: 'd-none d-sm-none d-md-none d-lg-none d-xl-table-cell'
        },
        {
          key: 'group_id',
          sortable: true,
          label: 'Group',
          tdClass: 'd-none d-sm-none d-md-none d-lg-table-cell d-xl-table-cell',
          thClass: 'd-none d-sm-none d-md-none d-lg-table-cell d-xl-table-cell'
        },
        { key: 'survey_name', sortable: true },
        {
          key: 'survey_start_date',
          sortable: true,
          label: 'Start date',
          tdClass: 'd-none d-sm-none d-md-none d-lg-none d-xl-table-cell',
          thClass: 'd-none d-sm-none d-md-none d-lg-none d-xl-table-cell'
        },
        {
          key: 'survey_end_date',
          sortable: true,
          label: 'End date',
          tdClass:
            'd-none d-sm-none d-md-table-cell d-lg-table-cell d-xl-table-cell',
          thClass:
            'd-none d-sm-none d-md-table-cell d-lg-table-cell d-xl-table-cell'
        },
        { key: 'survey_status', sortable: false, label: 'Replied' },
        { key: 'survey_deleted', class: 'col-1', label: '', sortable: false }
      ],
      deleteconfirm: 1,
      surveys: []
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    },
    mygdqpage_reload: {
      get () {
        return this.$store.state.mygdqpage_reload
      }
    },
    setadmin_done: {
      get () {
        return this.$store.state.questionnaire_admin_done
      }
    }
  },
  watch: {
    mygdqpage_reload () {
      this.loading = true
      this.surveys_get()
    },
    setadmin_done () {
      this.loading = true
      this.surveys_get()
    }
  },
  created () {
    this.loading = true
    this.surveys_get()
    this.$store.dispatch('questionnaire_setadmin', { admin: false })
    this.$store.dispatch('questionnaire_setadmin_code', { code: '' })
    this.$store.dispatch('questionnaire_setadmin_done', { done: false })
  },
  methods: {
    surveyTypeName (id) {
      id = Number(id)
      switch (id) {
        case 1:
          return 'Draft'
        case 2:
          return 'Scheduled'
        case 3:
          return 'Ongoing'
        case 4:
          return 'Completed'
        default:
          return 'Default'
      }
    },
    async survey_deletefromdatabase (id) {
      this.wipeconfirm = false
      this.wipeprogress = true
      await this.$store.dispatch('groupsurvey_wipe', { id })
      this.wipesurvey = 0
      console.log('Wiped')
      this.loading = true
      this.surveys_get()
      this.wipeprogress = false
    },
    survey_delete (id, survey_deleted) {
      this.deleteconfirm = 1
      if (survey_deleted === 0) {
        if (
          confirm(
            'Are you sure you want to delete this survey?'
          )
        ) {
          console.log('confirmed')
          this.deleteconfirm = 1
        } else {
          this.deleteconfirm = 0
        }
      }
      if (this.deleteconfirm === 1) {
        const newstatus = 1 - survey_deleted
        const survey = {
          id,
          survey_deleted: newstatus
        }
        this.$store
          .dispatch('groupsurvey_update', { survey })
          .then(() => {
            this.surveys_get()
          })
      }
    },
    selectall (selected) {
      const setselectto = !selected
      for (let i = 0; i < this.surveys.length; i++) {
        this.surveys[i].selected = setselectto
      }
      this.countselected()
    },
    countselected () {
      const selectedsurveys = []
      let numbersel = 0
      for (let i = 0; i < this.surveys.length; i++) {
        if (this.surveys[i].selected) {
          selectedsurveys.push(this.surveys[i].id)
          numbersel++
        }
      }
      this.surveysselected = numbersel
      this.$store.dispatch('groupsurveys_setselected', {
        surveys: selectedsurveys
      })
    },
    surveys_get () {
      this.loading = true
      const filter = {
        user_id: {
          operator: '=',
          value: this.consultant_id,
          realfield: 1
        },
        survey_deleted: {
          operator: '=',
          value: 0,
          realfield: 1
        },
        survey_status_id: {
          operator: '!=',
          value: 4,
          realfield: 1
        }
      }
      const limit = 10
      const start = 0
      this.$store.dispatch('surveys_fetch', { filter, limit, start }).then((resp) => {
        this.surveys = resp.data.result
        this.surveys_retrieved = resp.data.result.length
        this.surveys_total = resp.data.total
        if (resp.data.result.length === 0) {
          const newfilter = {
            ...filter,
            survey_status_id: {
              operator: '<',
              value: 5,
              realfield: 1
            }
          }
          this.$store.dispatch('surveys_fetch', { filter: newfilter, limit, start }).then((resp2) => {
            this.surveys = resp2.data.result
            this.surveys_retrieved = resp2.data.result.length
            this.surveys_total = resp2.data.total
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    openSurveyPage (item) {
      this.$store
        .dispatch('groupsurvey_setcurrent', { survey_id: item.id })
        .then(() => {
          if (item.survey_status_id === 1) {
            // Here add anhy group members that are not members of the survey
            this.$store.dispatch('groupsurveymembers_addnewgroupmembers', { survey_id: item.id })
            this.$router.push('/create/group/survey/details')
          } else {
            this.$router.push('/group/survey')
          }
        })
    },
    getClassColor (type, survey) {
      if (type === 'member') {
        const { completecount, membercount } = survey
        if (completecount === 0) {
          return 'bg-danger'
        } else if (completecount > 0 && completecount < membercount) {
          return 'bg-warning'
        } else if (completecount === membercount) {
          return 'bg-secondary'
        }
      } else if (type === 'status') {
        const status_id = Number(survey.survey_status_id)
        switch (status_id) {
          case 1:
            return 'bg-danger'
          case 2:
            return 'bg-secondary'
          case 3:
            return 'bg-warning'
          case 4:
            return 'bg-primary'
          default:
            return ''
        }
      }
      return ''
    },
    filter_it (row, filter) {
      let include = true
      if (filter === 'drafts') {
        if (row.survey_status_id !== 1 || row.survey_deleted === 1) {
          include = false
        }
      }
      if (filter === 'upcoming') {
        if (row.survey_status_id !== 2 || row.survey_deleted === 1) {
          include = false
        }
      }
      if (filter === 'ongoing') {
        if (row.survey_status_id !== 3 || row.survey_deleted === 1) {
          include = false
        }
      }
      if (filter === 'finished') {
        if (row.survey_status_id !== 4 || row.survey_deleted === 1) {
          include = false
        }
      }
      if (filter === 'deleted') {
        if (row.survey_deleted !== 1) {
          include = false
        }
      }
      return include
    },
    format_date (date) {
      const d = new Date(date)
      let month = '' + (d.getMonth() + 1)
      let day = '' + d.getDate()
      const year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('')
    },
    format_time (date) {
      const d = new Date(date)
      const h = d.getHours()
      const m = d.getMinutes()
      const hour = (h > 9 ? '' : '0') + h
      const minute = (m > 9 ? '' : '0') + m
      const thistime = hour + ':' + minute
      return thistime
    }
  }
}
</script>
<style>
td {
  cursor: pointer !important;
}
</style>
